import { forwardRef, type Ref, type SVGProps } from "react";

function Dollar(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.86341 1.99922V1.19922M4.86341 17.9992V18.7992M8.20997 5.19922C7.54197 4.24274 6.29342 3.59922 4.86341 3.59922H4.43415C2.53752 3.59922 1 4.87272 1 6.44366V6.56578C1 7.68943 1.76647 8.71664 2.97985 9.21916L6.74698 10.7793C7.96036 11.2818 8.72683 12.309 8.72683 13.4327C8.72683 15.071 7.1233 16.3992 5.14525 16.3992H4.86341C3.43341 16.3992 2.18486 15.7557 1.51686 14.7992"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(Dollar);
export default ForwardRef;
